import { Cpu, Send } from "lucide-react";
import { BrandIcon } from "../icon-bank/BrandIcon";
import type { ProviderIconName } from "./provider-options";

interface ProviderIconProps {
  icon: ProviderIconName;
  className?: string;
}

export function ProviderIcon({ icon, className }: ProviderIconProps) {
  if (icon === "chip") return <Cpu className={className} strokeWidth={1.8} />;
  if (icon === "moonshot")
    return <Send className={className} strokeWidth={1.8} />;
  return <BrandIcon name={icon} className={className} fallback />;
}
